import { createStyles } from 'game/lib/createStyles';
import { PropsWithChildren } from 'react';

const classes = createStyles({
  layer: {
    position: 'fixed',
    zIndex: 1,
    maxWidth: 600,
    height: 'calc(100% - 20px)',
    width: '100%',
    padding: 20,
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    pointerEvents: 'none',
  },
  layerInner: {
    maxHeight: '100%',
    pointerEvents: 'auto',
  },
});

export const Layer: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={classes.layer}>
      <div className={classes.layerInner}>
        {children}
      </div>
    </div>
  );
};
